export function accountSettings() {
  return "/account/profile";
}

export function unauthorized() {
  return "/unauthorized";
}
